import { useRef } from 'react';
import { newIdempotencyKey } from '../api/client';

export interface IdempotentSubmit {
  /** 同じ内容の押し直しには同じ鍵を返す。内容が変わるか、前の送信が成功していれば新しい鍵にする。 */
  keyFor(fingerprint: string): string;
  /** 送信に成功したら忘れる（同じ内容をもう一度送るのは別の要求なので、新しい鍵で送る）。 */
  done(): void;
}

/**
 * Idempotency-Key の作り方（計画の調整 C37）。押すたびに新しい鍵を作ると、応答だけを落としたときの
 * 押し直しが「同じ要求の再生」にならず、記憶の作成や指示の投入が二重に通る。失敗した送信の鍵だけを
 * 覚えておき、同じ内容で押し直したときに使い回す。
 */
export function useIdempotencyKey(): IdempotentSubmit {
  const attempt = useRef<{ fingerprint: string; key: string } | null>(null);
  return {
    keyFor(fingerprint: string) {
      const current = attempt.current;
      if (current !== null && current.fingerprint === fingerprint) return current.key;
      const key = newIdempotencyKey();
      attempt.current = { fingerprint, key };
      return key;
    },
    done() {
      attempt.current = null;
    },
  };
}
